import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, map } from 'rxjs';
import { file } from 'src/assets/mock/selectedFile'
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    fileData: any = file;
    selectedLanguage: any = {};
    selected_file: any = undefined;
    RecordedAudioDuration: any;
    transcript: any;
    from_my_files: number = 0;

    public allFiles = new BehaviorSubject<any>('');
    public currentSelectedFileData = new BehaviorSubject<any>('');

    constructor(private httpClient: HttpClient) { }

    isLogin = new BehaviorSubject<boolean>(false);
    selectedLanguageSubject = new BehaviorSubject<any>("");
    loggedInUser = new BehaviorSubject<any>("");

    getImage(): Observable<Blob> {
        return this.httpClient
            .get('https://graph.microsoft.com/v1.0/me/photo/$value', {
                responseType: 'blob',
                headers: new HttpHeaders({ 'Content-Type': 'image/jpeg' }),
            }).pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    getUserDetails() {
        return this.httpClient.get('https://graph.microsoft.com/v1.0/me')
    }

    setSelectedLanguage(language: any) {
        const currentValue = this.selectedLanguageSubject.value;
        if (!this.selectedLanguageSubject.value.includes(language.name)) {
            const updatedValue = [...currentValue, language.name];
            this.selectedLanguageSubject.next(updatedValue);
        }
    }

    getSelectdLanguage() {
        return this.selectedLanguageSubject;
    }


    get_storage_cdn_url(url: string) {
        let domain = (new URL(url));
        let storage_cdn = environment.storage_cdn_url
        if (domain.origin.toLowerCase() !== storage_cdn.toLowerCase() ) {
            let current_url = storage_cdn + domain.pathname
            return current_url;
        }
        return url;
    }
}